import protectAxios from "./axios";

export async function getMe(redirect : boolean) {

  const resp = await protectAxios.get(
     `usermanagement/me`,
  );
  return resp.data;
}